import React, { useState, useEffect } from 'react'
import { FiSearch, FiMoreVertical } from 'react-icons/fi'
import { useNavigate } from 'react-router-dom'
import { Menu, MenuItem } from '@mui/material'
import CreateBotModal from './components/CreateBotModal'
import './AllBots.css'
import DeleteAiBot from './components/DeleteAiBot'
import Modal from 'react-modal'

const AllBots = () => {
  const navigate = useNavigate()
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [bots, setBots] = useState<any>([])
  const [searchQuery, setSearchQuery] = useState('')
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const [selectedBot, setSelectedBot] = useState<any>(null)
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState<boolean>(false)

  const handleCreateBot = (data: { name: string; description: string; expiryDate: string }) => {
    console.log('Creating bot:', data)

    setIsModalOpen(false)
    // You can call the bot creation API here
  }

  const handleClickMoreOptions = (event: React.MouseEvent<HTMLElement>, bot: any) => {
    setAnchorEl(event.currentTarget)
    setSelectedBot(bot)
    console.log(bot)
  }

  const handleCloseMenu = () => {
    setAnchorEl(null)
  }

  const customExpiryModalStyles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-50%, -50%)',
      borderRadius: '15px',
      border: 'none',
      boxShadow: '0 2px 8px 0 #00000029'
    }
  }
  const handleEditBot = () => {
    if (selectedBot) {
      console.log('Editing bot:', selectedBot)
      // Navigate to the edit page or open a modal for editing
      navigate(`/ai-bots/ai-bot-builder/${selectedBot?.id}`)
      localStorage.setItem('agenticId', selectedBot?.app_id)
    }
    handleCloseMenu()
  }

  const handleDeleteBot = () => {
    if (selectedBot) {
      console.log('Deleting bot:', selectedBot)
      setIsDeleteModalOpen(true)
    }
    handleCloseMenu()
  }
  const afterOpenDeleteModal = () => {
    // subtitle.style.color = '#f00'
  }

  const closeDeleteModal = () => {
    setIsDeleteModalOpen(false)
  }
  const fetchBots = async () => {
    try {
      const token = localStorage.getItem('auth-token')
      const url = `${process.env.REACT_APP_RESUME_PARSER_URL}/ai-chatbots/bots`

      const response = await fetch(url, {
        method: 'GET',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${token}`
        }
      })

      if (!response.ok) {
        throw new Error('Failed to fetch bots')
      }

      const data = await response.json()
      setBots(data)
    } catch (error) {
      console.error('Error fetching bots:', error)
    }
  }
  useEffect(() => {
    fetchBots()
  }, [])

  const filteredBots = bots?.filter((bot: any) =>
    bot?.chatbot?.name?.toLowerCase().includes(searchQuery.toLowerCase())
  )

  return (
    <div className='card p-10'>
      <div className='d-flex justify-content-between mb-10'>
        <div className='title-section'>
          <h1>
            Chatbots <span className='beta-tag'>Beta</span>
          </h1>
        </div>
        <div className='header-right'>
          {/* <span className='plan-info'>
            My plan: Free (2/2 Chatbots used) • <a href='#upgrade'>Upgrade</a>
          </span> */}
          <button className='create-button' onClick={() => setIsModalOpen(true)}>
            + Create
          </button>
        </div>
      </div>

      <div className='trial-banner'>
        {/* <div className='banner-content'>
          <span>🚀 Your free trial of the Chatbots Advanced plan has ended!</span>
          <p>
            Upgrade to a paid plan or extend your trial to continue building with all functionality.
          </p>
          <div className='banner-buttons'>
            <button className='upgrade-button'>Upgrade Chatbots</button>
            <button className='extend-button'>Extend trial for 3 more days</button>
          </div>
        </div> */}
        <div className='agentic-banner'>
          <div className='banner-content'>
            <span>🤖 Your Agentic Bot is ready to assist!</span>
            <p>Explore all your bots below and start interacting with them.</p>
          </div>
        </div>
      </div>

      <div className='search-container'>
        <FiSearch className='search-icon' />
        <input
          type='text'
          placeholder='Search...'
          className='search-input'
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
        />
      </div>

      <table className='bots-table'>
        <thead>
          <tr>
            <th>Name</th>
            <th>Description</th>
            <th>Model</th>
            <th>Updated</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
          {filteredBots.length > 0 ? (
            filteredBots.map((bot: any) => (
              <tr key={bot.chatbot.id} className='cursor-pointer'>
                <td>{bot.chatbot.name}</td>
                <td>{bot.chatbot.description || 'No description'}</td>
                <td>ChatGPT</td>
                <td>{new Date().toLocaleDateString()}</td>
                <td>
                  <FiMoreVertical
                    className='more-icon'
                    onClick={(e: any) => handleClickMoreOptions(e, bot.chatbot)}
                  />
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan={5} className='text-center'>
                No bots found
              </td>
            </tr>
          )}
        </tbody>
      </table>

      {/* Menu for Edit and Delete Options */}
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleCloseMenu}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left'
        }}
        style={{ marginTop: '20px', width: '500px' }}
      >
        <MenuItem onClick={handleEditBot}>
          <i className='bi bi-pencil-square me-2'></i> Edit
        </MenuItem>
        <MenuItem onClick={handleDeleteBot}>
          <i className='bi bi-trash me-2 text-danger'></i> Delete
        </MenuItem>
      </Menu>

      <CreateBotModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSubmit={handleCreateBot}
        fetchBots={fetchBots}
      />

      <Modal
        isOpen={isDeleteModalOpen}
        onAfterOpen={afterOpenDeleteModal}
        onRequestClose={closeDeleteModal}
        style={customExpiryModalStyles}
        contentLabel='Delete Bot'
      >
        <DeleteAiBot bot={selectedBot} fetchBots={fetchBots} closeDeleteModal={closeDeleteModal} />
      </Modal>
    </div>
  )
}

export default AllBots
